import React from 'react';

export function MoreIcon({ ...props }) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M5.00033 9.99992C5.00033 10.9204 4.25413 11.6666 3.33366 11.6666C2.41318 11.6666 1.66699 10.9204 1.66699 9.99992C1.66699 9.07944 2.41318 8.33325 3.33366 8.33325C4.25413 8.33325 5.00033 9.07944 5.00033 9.99992ZM11.667 9.99992C11.667 10.9204 10.9208 11.6666 10.0003 11.6666C9.07985 11.6666 8.33366 10.9204 8.33366 9.99992C8.33366 9.07944 9.07985 8.33325 10.0003 8.33325C10.9208 8.33325 11.667 9.07944 11.667 9.99992ZM16.667 11.6666C17.5875 11.6666 18.3337 10.9204 18.3337 9.99992C18.3337 9.07944 17.5875 8.33325 16.667 8.33325C15.7465 8.33325 15.0003 9.07944 15.0003 9.99992C15.0003 10.9204 15.7465 11.6666 16.667 11.6666Z" />
    </svg>
  );
}
